import React from 'react';
//material
import {Card, CardContent, withStyles, Divider, Grid} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './group-card-styles';

const GroupCardView = (props) => {
  const {classes, isLoading, group} = props;

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.eventName}>
              { group.name }
            </div>
        }

        <Grid container>
          {
            (isLoading || group.club) &&
            <Grid item xs={12} md={6}>
              {
                isLoading ?
                  <Skeleton height={22} width={'40%'} /> :
                  <div className={classes.subheader}>
                    {group.club.name}
                  </div>
              }
            </Grid>
          }
        </Grid>

        <Divider className={classes.divider} />

        {
          isLoading ?
            <Skeleton height={52} width={'40%'} className={classes.description} /> :
            <div className={classes.description}>
              {group.description}
            </div>
        }
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (GroupCardView);
